import React from "react";
import PropTypes from "prop-types";

import SiderBarItem from "@/react-components/SiderBar/Item";
import SiderBarSubItem from "@/react-components/SiderBar/SubItem";

class FirstLevelMenu extends React.Component {
  click = (item) => {
    const { click } = this.props;
    this.selected(item);
    click && click(item);
  };

  subItemClick = (item) => {
    const { subItemClick } = this.props;
    this.selected(item);
    subItemClick && subItemClick(item);
  };

  selected = (item) => {
    const { menuList, subMenuList } = this.props;
    menuList.forEach((item1) => (item1.active = false));
    subMenuList.forEach((item1) => (item1.active = false));
    item.active = true;
    if (item.secondary) {
      item.children[0].active = true;
    }
  };

  render() {
    const { menuList, subMenuList, toggleMenuFold } = this.props;
    return (
      <nav className="menu-nav-container">
        <div className="nav">
          {menuList.map((item, index) => (
            <SiderBarItem
              key={index}
              item={item}
              click={() => this.click(item)}
            />
          ))}
        </div>
        <div className="menu-divider" />
        <div className="sub-nav">
          {subMenuList.map((item, index) => (
            <SiderBarSubItem
              key={index}
              item={item}
              click={() => this.subItemClick(item)}
            />
          ))}
        </div>
        <div className="menu-fold-button" onClick={toggleMenuFold} tabIndex="0">
          <i />
        </div>
      </nav>
    );
  }
}

FirstLevelMenu.propTypes = {
  menuList: PropTypes.array.isRequired,
  subMenuList: PropTypes.array.isRequired,
  click: PropTypes.func,
  subItemClick: PropTypes.func,
  toggleMenuFold: PropTypes.func,
};

FirstLevelMenu.defaultProps = {
  click: undefined,
  subItemClick: undefined,
  toggleMenuFold: undefined,
};

export default FirstLevelMenu;
